import { useIsApiReady } from "@/hooks/use-api-ready";
import { usageControllerGetUsage } from "@/lib/gen-api";
import { queryKeys } from "@/lib/query-keys";
import { useQuery } from "@tanstack/react-query";

export const useUsageData = (params: { groupUuid: string | null }) => {
  const { groupUuid } = params;
  const ready = useIsApiReady() && !!groupUuid;

  const { data: usage } = useQuery({
    enabled: ready,
    queryKey: queryKeys.usage({ groupUuid: groupUuid! }),
    queryFn: async () => {
      const response = await usageControllerGetUsage({
        query: {
          filter: {
            groupUuid: groupUuid!,
          },
        },
      });
      return response.data;
    },
  });

  return {
    usage,
  };
};
